import { render, staticRenderFns } from "./ImageLightbox.vue?vue&type=template&id=c296d452&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"
import style0 from "./ImageLightbox.vue?vue&type=style&index=0&id=c296d452&prod&lang=scss&scoped=true"
import style1 from "./ImageLightbox.vue?vue&type=style&index=1&id=c296d452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c296d452",
  null
  
)

export default component.exports